import React from 'react';
import classnames from 'classnames';
import './CheckmarkList.module.css';

const CheckmarkList = ({
  items,
  width,
  listStyle = 'checkList',
  fontSize = 0,
  margin = 2,
  light,
  narrow = false
}) => {
  return (
    <div>
      <div styleName="list-container">
        {items.map((item, index) => {
          return (
            <div
              key={index}
              styleName={classnames(
                `width-${width}`,
                `margin-vertical-${margin}`,
                {
                  light,
                  narrow,
                  itemCheckList: listStyle === 'checkList',
                  itemBlueDots: listStyle === 'blueDots'
                }
              )}
            >
              <span styleName={`font-size-${fontSize}`}>{item}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckmarkList;
